import React from 'react';
import { Cpu } from 'lucide-react';
import type { GlassBoxItem } from '../../../hooks/useGlassBoxEvents';

interface Props {
  item: GlassBoxItem;
}

export function LLMCallEvent({ item }: Props) {
  const { data } = item;
  const model = typeof data.model === 'string' ? data.model : null;
  const durationMs = typeof data.duration_ms === 'number' ? data.duration_ms : null;
  const inputTokens = typeof data.input_tokens === 'number' ? data.input_tokens : null;
  const outputTokens = typeof data.output_tokens === 'number' ? data.output_tokens : null;
  const isComplete = item.event.includes('complete');

  return (
    <div className="flex items-start gap-2 py-1.5 px-3 hover:bg-surface-800/40 rounded group">
      <div className="mt-0.5 flex-shrink-0">
        <Cpu className="w-3.5 h-3.5 text-primary-400" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-medium text-primary-300">
            {isComplete ? 'LLM complete' : 'LLM call'}
          </span>
          {model && (
            <span className="text-[10px] text-text-muted font-mono">{model}</span>
          )}
          {durationMs !== null && (
            <span className="text-[10px] text-text-muted">{durationMs}ms</span>
          )}
          {(inputTokens !== null || outputTokens !== null) && (
            <span className="text-[10px] text-text-muted">
              {inputTokens ?? '?'}→{outputTokens ?? '?'} tok
            </span>
          )}
        </div>
        {/* Duration bar */}
        {durationMs !== null && (
          <div className="mt-1 h-0.5 rounded-full bg-surface-700 w-full overflow-hidden">
            <div
              className="h-full rounded-full bg-primary-500/60"
              style={{ width: `${Math.min(100, (durationMs / 10000) * 100)}%` }}
            />
          </div>
        )}
      </div>
      <div className="flex-shrink-0 text-[10px] text-text-muted opacity-0 group-hover:opacity-100 transition-opacity">
        {new Date(item.receivedAt).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </div>
    </div>
  );
}
